import React, { useContext } from "react";
import { CardBody, Col, Label, Row } from "reactstrap";
import { formatDateForDisplay } from "../../Utils/UtilityFunctions";
import { ViewOfferContext } from "./context";

const ViewOfferGrantsOneTime = ({ grantsOneTimeList }) => {
  const { sectionRefs } = useContext(ViewOfferContext);
  return (
    <CardBody>
      {grantsOneTimeList?.length === 0 ? (
        <div className="text-center">No Grants</div>
      ) : (
        grantsOneTimeList?.map((grant, index) => {
          const grantRef = sectionRefs.current[`grants${index + 1}`];
          return (
            <div
              key={index}
              className="border border-opacity-50 rounded-0 mb-3"
              ref={grantRef}
            >
              <Row
                className={`mb-3 px-3 pt-3 ${
                  index === grantsOneTimeList?.length - 1 ? "" : "border-bottom"
                }`}
                key={index}
              >
                <Col
                  xs={12}
                  className="d-flex justify-content-between align-items-center pb-4"
                >
                  <h3 className="card-title mb-0">
                    Grant {index > 0 ? index + 1 : ""}
                  </h3>
                </Col>

                <Col xs={12} md={6} lg={4} xxl={3}> 
                  <Label
                    for={`grants[${index}].resourceType`}
                    className="fw-bold"
                  >
                    Resource Type
                  </Label>
                  <p>
                    {grant?.resourceType ? grant?.resourceType?.label : "-"}
                  </p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label
                    for={`grants[${index}].resourceValue`}
                    className="fw-bold"
                  >
                    Resource Value
                  </Label>
                  <p>{grant?.resourceValue ? grant?.resourceValue : "-"}</p>
                </Col>

                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label className="fw-bold">Type of Resource</Label>
                  <p>{"Non-Currency"}</p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label for={`grants[${index}].ceiling`} className="fw-bold">
                    Ceiling
                  </Label>
                  <p>{grant?.ceiling ? grant?.ceiling : "-"}</p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label for={`grants[${index}].floor`} className="fw-bold">
                    Floor
                  </Label>
                  <p>{grant?.floor ? grant?.floor : "-"}</p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label for={`grants[${index}].infinite`} className="fw-bold">
                    Infinite
                  </Label>
                  <p>{grant?.infinite ? grant?.infinite?.label : "-"}</p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label className="fw-bold">Override</Label>
                  <p>{grant?.override ? "Yes" : "No"}</p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label
                    for={`grants[${index}].validityStartsOn`}
                    className="fw-bold"
                  >
                    Validity Starts
                  </Label>
                  <p>
                    {grant?.validityStartsOn
                      ? grant?.validityStartsOn?.label
                      : "-"}
                  </p>
                </Col>
                {grant?.validityStartsOn?.label === "Specific Time" && (
                  <Col xs={12} md={6} lg={4} xxl={3}>
                    <Label className="fw-bold">Start Date and Time</Label>
                    <p>
                      {grant?.startDateTime
                        ? formatDateForDisplay(grant?.startDateTime)
                        : "-"}
                    </p>
                  </Col>
                )}

                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label
                    for={`grants[${index}].validityEndsOn`}
                    className="fw-bold"
                  >
                    Validity Ends
                  </Label>
                  <p>
                    {grant?.validityEndsOn ? grant?.validityEndsOn?.label : "-"}
                  </p>
                </Col>
                {grant?.validityEndsOn?.label === "Specific Time" && (
                  <Col xs={12} md={6} lg={4} xxl={3}>
                    <Label>End Date and Time</Label>
                    <p>
                      {grant?.endDateTime
                        ? formatDateForDisplay(grant?.endDateTime)
                        : "-"}
                    </p>
                  </Col>
                )}
                {grant?.validityEndsOn?.label === "Relative" && (
                  <Col xs={12} md={6} lg={4} xxl={3}>
                    <Label className="fw-bold">Time Period</Label>
                    <p>
                      {`${
                        grant?.grantValidityEndsOnTimeperiod
                          ? grant?.grantValidityEndsOnTimeperiod
                          : "-"
                      } ${
                        grant?.grantValidityEndsOn
                          ? grant?.grantValidityEndsOn?.label
                          : ""
                      }`}
                    </p>
                  </Col>
                )}
              </Row>
            </div>
          );
        })
      )}
    </CardBody>
  );
};

export default ViewOfferGrantsOneTime;
